/** @type {string} */
const alertString = "alert";
export default alertString;
